import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { setRefetch, setRefetchKey } from '../../../features/global/globalSlice';
import BreadCrumb from '../../../layout/BreadCrumb';
import { Tabs } from 'antd';
import SchemeTable from './SchemeTable';
import ProjectsTable from './ProjectsTable';
import WtrStorage from './wtr-storage/WtrStorage';
import Reclamation from './reclamation/Reclamation';

function PathwaysViewList() {
    const dispatch = useDispatch();
    const [active, setactive] = useState("1");   
    const { activeObjPathCard } = useSelector((state) => ({
      activeObjPathCard: state.obj.activeObj["pathwayCard"],
    }));
    async function refetching(activeKey) { 
      setactive(activeKey);
      await dispatch(setRefetch());
      await dispatch(setRefetchKey(activeKey));
    }
  
    const tabConfigurations = [
      {
        label: (
          <span className="flex items-center">
            <span className=" ">Schemes</span>
          </span>
        ),
        key: "1",
        children: <SchemeTable />,
      },
      {
        label: (
          <span className="flex items-center">
            <span className=" " >Land Reclamation</span>
          </span>
        ),
        key: "2",
        children: <Reclamation/>,
      },
      {
        label: (
          <span className="flex items-center">
            <span className=" ">Projects</span>
          </span>
        ),
        key: "3",
        children:  <ProjectsTable />,
      },
      {
        label: (
          <span className="flex items-center">
            <span className=" ">Water Storage Projects</span>
          </span>
        ),
        key: "4",
        children: <WtrStorage/>,
      },
      
    ];
  return (
    <>
      <BreadCrumb
        breadcrumbs={[
          { title: "Pathways", path: "/rob/pathway-overview" },
          { title: `OverView` },
        ]}
      />
      
      <div className="white_card mt-[2.41rem] flex-1 min-h-[80vh]">
        <div className="form-add-h">{activeObjPathCard?.irrigationPathwayName}</div>
        <Tabs
          items={tabConfigurations}
          defaultActiveKey="1"
          activeKey={active}
          onChange={refetching}
          className="mt-[1.75rem] iwua-tab-holder  iwua-tabs-btn iwua-tabs-btn-inactive iwua-ink-bar iwua-nav-list "
        />
      </div>
    </>
  )
}

export default PathwaysViewList
